// 订单类型
export const ORDER_TYPES = {
  // 个人订单
  personal: {
    name: '个人订单',
    value: 10,
  },
  // 企业子订单
  enterprise: {
    name: '企业子订单',
    value: 20,
  },
}

// 订单状态
export const ORDER_STATES = {
  confirmOrderWaiting: {
    name: '合同待签署',
    value: 0,
  },
  sendCarCheckoutWaiting: {
    name: '发车待验车',
    value: 1500,
  },
  processing: {
    name: '履约中',
    value: 2500,
  },
  returnCarCheckoutWaiting: {
    name: '退车待验车',
    value: 3500,
  },
  checkoutOrderWaiting: {
    name: '订单待核算',
    value: 4500,
  },
  checkoutExpenseWaiting: {
    name: '费用待结算',
    value: 5000,
  },
  closed: {
    name: '已关闭',
    value: 5500,
  },
}

// 主订单状态
export const ENT_RENT_ORDER_STATES = {
  created: {
    name: '已创建',
    value: 1,
  },
  processing: {
    name: '进行中',
    value: 2,
  },
  closed: {
    name: '已关闭',
    value: 3,
  },
}
